module.exports = __webpack_public_path__ + "img/HoneyPot.fa972f87.png";